/**************************************************************************************************************************************************
*   MODULE NAME     :  AbstractDetail
*   AUTHOR          :  GLSD DEV Team
*   DATE            :  20-01-2021
*   DESCRIPTION     :  Component to load Abstract Detail page
*   Copyright 2021 Eli Lilly and Company
*   All rights reserved
*
/**************************************************************************************************************************************************
*   *** CHANGE HISTORY ***
/**************************************************************************************************************************************************
*   TRACKING NUMBER: CHG1689267
*   DESCRIPTION: <GLSD>: New System Development
**************************************************************************************************************************************************
*   TRACKING NUMBER: CHG2467262
*   DESCRIPTION: <GLSD>: Node 20 Upgrade and Implement MSAL
*   DATE: 29-Jan-2025
**************************************************************************************************************************************************
*   TRACKING NUMBER: CHG2517014
*   DESCRIPTION: <GLSD>: Layer7 API Deprecation
*   removed unused/commented code
*   DATE: 28-Feb-2025
/**************************************************************************************************************************************************/
import React, { useContext } from 'react';
import axios from "axios";
import { Container, Row, Col, Form, Button, InputGroup, Accordion, Card, Badge, OverlayTrigger, Popover } from "react-bootstrap";
import AccordionContext from 'react-bootstrap/AccordionContext';
import { useAccordionToggle } from 'react-bootstrap/AccordionToggle';
import { FaSearch, FaCheckCircle, FaChevronDown, FaSpinner, FaSyncAlt } from "react-icons/fa";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { bindActionCreators } from "redux";
import Select from "react-select";
import swal from "sweetalert";
import "./AbstractDetail.css";
import config from "../../../config.json";
import ToggleSwitch from "../../common/toggleSwitch/ToggleSwitch";
import DataTable from '../../common/dataTable/DataTable';
import EllipsisModal from "../Common/EllipsisModal";
import SearchAbstractModal from "../Common/SearchAbstractModal";
import MyDatePicker from "../../common/datePicker/MyDatePicker";
import { VALIDATION_OBJ } from "../Common/AbstractFormValidation";
import { yyyymmddFormat } from "../../common/DateFormat";
import { AuthProvider } from "../../../auth/index"
import {
    loadAllProduct,
    loadAllCountry,
    loadAllExplanation,
    loadAllStatus,
    loadAbstractDetail,
    loadAllAlerts,
    updateAbstract,
    lockAbstract,
    unlockAbstract,
    getAbstractLockedByData,
    uploadAbstractAttachment,
    loadAbstractAttachments,
    addOrUpdateAbstractAttachment,
    archiveAttachment
} from "../../../actions/abstractActions";
import * as MessagePool from '../../common/MessagesPool';
import * as Helper from "../Common/abstractHelper";
import { DOCUMENT_SITE_ORIGIN, SITE_PROCESSING_DOCUMENT, STATUS } from "../../../constants/constants";


class AbstractDetail extends React.Component {

    constructor(props) {
        super(props);
        this.abstractDateFields = {
            dateRecordReceived: null,
            dateTranslationRequested: null,
            dateArticleOrdered: null,
            dateTranslationReceived: null,
            dateArticleOrdered2: null,
            dateAbstractValid: null,
            dateArticleReceived: null,
            dateArticleValid: null,
            dateAbstractReviewed: null,
            dateFlwUpReceived: null,
            dateArticleReviewed: null,
            dateClosed: null,
            dateTranslationValid: null,
            lockByDate: null
        }


        this.abstractFormInitialState = {
            originalAbstractId: null,
            title: '',
            originalTitle: '',
            authors: '',
            receivedFrom: '',
            source: '',
            productId: null,
            institution: '',
            caseIds: '',
            countryId: null,
            abstract: '',
            notes: '',
            keywords: '',
            documentSiteOrigin: true,
            siteProcessingDocument: '',
            urlToOvid: '',
            explanationId: null,
            urlToSourceDb: '',
            abstractLanguage: '',
            statusId: null,
            otherStatus: '',
            caseManagerId1: null,
            caseManagerId2: null,
            caseManagerId3: null,
            migrateFlag: false,
            enblAlrtsAndVldtinsFlag: true,
            ...this.abstractDateFields
        }
        this.role = this.props.loggedUserDetail.role;
        this.state = {
            abstractForm: this.abstractFormInitialState,
            abstractFormCopy: this.abstractFormInitialState,
            fileAttachment: [],
            fileAttachmentCopy: [],
            inactiveFileAttachment: [],
            inactiveFileAttachmentCopy: [],
            filesToUpload: [],
            action: this.role.includes('Business_Administrator') || this.role.includes('Literature_Associate') ? 'edit' : 'view',
            isFormValid: false,
            isPrimaryDetailsValid: false,
            isSecondaryDetailsValid: false,
            isDateDetailsValid: false,
            showEllipsisModal: false,
            showSearchAbstractModal: false,
            originalStatusId: '',
            staticTitle: '',
            staticOriginalStatusId: '',
            originalAbstractTitle: '',
            tempEnblAlrtsAndVldtinsFlag: null,
            modalData: '',
            productList: this.props.productData,
            statusList: this.props.statusData,
            explanationList: this.props.explanationData,
            countryList: this.props.countryData,
            statusName: '',
            caseManagerList: Helper.getFormattedCaseManagerList(this.props.loggedUserDetail),
            accordionExpandFlag: false,
            abstractDataList: [],
            accordionTabs: {
                event_key_0: true,
                event_key_1: true,
                event_key_2: true,
                event_key_3: true,
                action: 'view'
            },
            alertMasterData: null,
            daysOverdue: {
                absNotRevAftRecp: 0,
                transNotRetnAftReq: 0,
                artNotRecAftOrd: 0,
                artNotRevAftRec: 0
            }
        }

        this.abstractId = this.props.match.params.abstractId;
        this.abstractLockedBy = null;
        this.loggedUserSystemId = this.props.loggedUserDetail.userClientId;
    }

    /**
    * Function to hide/show loader.
    * @param isLoading whether to hide or show loader
    */
    setLoader = isLoading => this.setState({ isLoading });


    /**
     * Function to initiate life cycle hooks.
     */
    async componentDidMount() {
        try {
            await this.loadAbstractDetail();
            await Promise.all([
                this.loadAbstractAttachments(),
                this.loadAllExplanation(),
                this.loadAllProduct(),
                this.loadAllCountry(),
                this.loadAllStatus(),
                this.loadAllAlerts()
            ]);
            this.onPrint();
            this.calculateDaysOverdueCount();
        } catch (e) {
            console.log('Error', e);
            this.setLoader(false);
        }
    }

    async componentWillUnmount() {
        if (this.abstractLockedBy === this.loggedUserSystemId) {
            await this._unlockAbstract();
        }
    }
    /**
    * Adds listeners for crossbrowser print callback
    *
    */
    onPrint() {
        window.matchMedia('print').addEventListener('change', query => query.matches ? this.setState({
            ...this.state,
            accordionExpandFlag: false,
            accordionTabs: {
                ...this.state.accordionTabs,
                event_key_0: true,
                event_key_1: true,
                event_key_2: true,
                event_key_3: true
            }
        }) : null)
        window.addEventListener('beforeprint', () => this.setState({
            ...this.state,
            accordionExpandFlag: false,
            accordionTabs: {
                ...this.state.accordionTabs,
                event_key_0: true,
                event_key_1: true,
                event_key_2: true,
                event_key_3: true
            }
        }))
    }

    loadAllProduct = async () => {
        let arr = this.state.productList;
        if (!(this.state.productList && this.state.productList.length > 0)) {
            let response = await this.props.loadAllProduct();
            arr = response.data.result
        }
        let resultData = Helper.getFormattedMasterData(arr).sort((a, b) => a.label.localeCompare(b.label));
        this.setState({
            productList: resultData
        });
    }

    loadAllCountry = async () => {
        let arr = this.state.countryList;
        if (!(this.state.countryList && this.state.countryList.length > 0)) {
            let response = await this.props.loadAllCountry();
            arr = response.data.result
        }
        let resultData = Helper.getFormattedMasterData(arr).sort((a, b) => a.label.localeCompare(b.label));
        this.setState({
            countryList: resultData
        });
    }

    loadAllAlerts = async () => {
        this.setLoader(true);
        let response = await this.props.loadAllAlerts();
        let alertMasterData = {};
        response.data.result.forEach((e) => {
            alertMasterData[e.masterDataKey] = e.masterDataValue
        });
        await this.setState(prevState => ({
            alertMasterData: alertMasterData
        }))
        this.setLoader(false);
    }

    loadAllExplanation = async () => {
        let arr = this.state.explanationList;
        if (!(this.state.explanationList && this.state.explanationList.length > 0)) {
            let response = await this.props.loadAllExplanation();
            arr = response.data.result
        }
        let resultData = Helper.getFormattedMasterData(arr).sort((a, b) => a.label.localeCompare(b.label));
        resultData = Helper.getExplanationListByStatus(resultData, this.state.abstractForm.statusId.value);
        this.setState({
            explanationList: resultData
        });
    }

    loadAllStatus = async () => {
        let arr = this.state.statusList;
        if (!(this.state.statusList && this.state.statusList.length > 0)) {
            let response = await this.props.loadAllStatus();
            arr = response.data.result
        }
        let resultData = Helper.getFormattedMasterData(arr).sort((a, b) => a.label.localeCompare(b.label));
        let filteredStatusData = resultData.filter(el => ![STATUS.DUPLICATE].includes(el.value))
        this.setState({
            statusList: filteredStatusData
        });
    }


    TriggerEvent = async (e,data)=>{
        e.preventDefault();
        const config = {
            clientId: '0545c53a-54e3-4810-8a25-f1efc1a1fa75',
            openIdCallback: encodeURI('/auth/callback'),
            isGatewayScopeRequired: true,
            gatewayScopeType: 'non_production',
            logLevel: 'INFO',
          }
          // Initialize authProvider for authentication
        let authProvider = new AuthProvider(config);
        const openidAccessToken = await authProvider.getGatewayAccessToken();
        let payload = {
            //idToken: openidAccessToken.accessToken
        }
        //console.log(payload)
        let response = await axios.post(data, payload)
        window.open(response.data.url,"_blank")
    }

    /**
     * Calculates days overdue count for the abstracts based on date fields and Alerts
     */
    calculateDaysOverdueCount = async () => {
        let { alertMasterData, daysOverdue } = this.state;
        let { dateRecordReceived,
            dateAbstractReviewed,
            dateTranslationRequested,
            dateTranslationReceived,
            dateArticleOrdered,
            dateArticleReceived,
            dateArticleReviewed } = this.state.abstractForm;

        if (dateRecordReceived && !dateAbstractReviewed) {
            daysOverdue['absNotRevAftRecp'] = this._calAlertDaysCount(dateRecordReceived, alertMasterData['ALERT_DAYS_ABST_NOT_REVD']);
        } else {
            daysOverdue['absNotRevAftRecp'] = 0
        }
        if (dateTranslationRequested && !dateTranslationReceived) {
            daysOverdue['transNotRetnAftReq'] = this._calAlertDaysCount(dateTranslationRequested, alertMasterData['ALERT_DAYS_TRANS_NOT_RET']);
        } else {
            daysOverdue['transNotRetnAftReq'] = 0;
        }
        if (dateArticleOrdered && !dateArticleReceived) {
            daysOverdue['artNotRecAftOrd'] = this._calAlertDaysCount(dateArticleOrdered, alertMasterData['ALERT_DAYS_ART_NOT_RECVD']);
        } else {
            daysOverdue['artNotRecAftOrd'] = 0;
        }
        if (dateArticleReceived && !dateArticleReviewed) {
            daysOverdue['artNotRevAftRec'] = this._calAlertDaysCount(dateArticleReceived, alertMasterData['ALERT_DAYS_ART_NOT_REVD']);
        } else {
            daysOverdue['artNotRevAftRec'] = 0;
        }
        this.setState({ ...this.state, daysOverdue });
    }

    _calAlertDaysCount = (dateField, givenDays) => {
        let currDate = new Date();
        let timeDiff = currDate.getTime() - dateField.getTime();
        let daysDiff = Math.round(Math.abs(timeDiff / (1000 * 3600 * 24)));
        let alertDaysCount = timeDiff > 0 && givenDays < daysDiff ? daysDiff : 0;
        return alertDaysCount;
    }

    /**
     * Function to handle change
     */
    handleInputChange = (event) => {
        let identifier = event.target.name;
        let value = event.target.value;
        if (identifier === 'caseIds') {
            value = Helper.getFormattedCaseIds(value);
        }
        this._validateForm(identifier, value);
    }

    handleEnableAlertsValidationChange = (event) => {
        let identifier = event.target.name;
        let value = event.target.checked ? "1" : "0";
        let action = event.target.checked ? "edit" : "view";
        this._validateForm(identifier, value, { action, tempEnblAlrtsAndVldtinsFlag: 1 });
    }


    /**
     * Function to validate the Form
     * @param {*} identifier
     * @param {*} value
     */

    _validateForm = (identifier, value, updOptionalData = {}) => {
        let updForm = { ...this.state.abstractForm }
        updForm[identifier] = value;
        VALIDATION_OBJ.init(updForm);

        if (VALIDATION_OBJ[identifier].shouldValidate === true) {
            VALIDATION_OBJ.applyValidation(identifier, value);
        }
        // Refresh Original Abstract Field on Status Change
        if (identifier === 'statusId') {
            updForm['originalAbstractId'] = null;
            updForm['explanationId'] = null;
            VALIDATION_OBJ.applyValidation('explanationId', null);
            let statusId = value ? value.value : null;
            if (statusId) {
                updOptionalData['explanationList'] = Helper.getExplanationListByStatus(this.state.explanationList, statusId);
            }
            updOptionalData.originalAbstractTitle = '';
        }
        let formValidityResult = VALIDATION_OBJ.checkFormValidity();
        this.setState({
            ...this.state,
            ...updOptionalData,
            ...formValidityResult,
            showEllipsisModal: false,
            abstractForm: updForm
        });
    }

    /**
     * Function to handle the Dropdown onChange event
     * @param {*} identifier
     * @param {*} value
     */
    handleSelectChange = (identifier, value) => {
        this._validateForm(identifier, value)
    }

    /**
     * Function to handle the onDateChange event
     * @param {*} identifier
     * @param {*} value
     */
    handleDateChange = (identifier, value) => {
        this._validateForm(identifier, value);
    }

    onChangeHandler = event => {
        if (event.target.files && event.target.files[0]) {
            let fileName = event.target.files[0].name;
            var reader = new FileReader();

            reader.readAsDataURL(event.target.files[0]); // read file as data url

            reader.onload = (evt) => { // called once readAsDataURL is completed

                this.setState({
                    ...this.state,
                    file: {
                        name: fileName,
                        dataUrl: evt.target.result
                    }
                })
            }
        }
    }

    /**
     * Function to handle Switch events
    **/
    handleSwitch = ev => {
        this.setState({
            ...this.state,
            abstractForm: {
                ...this.state.abstractForm,
                documentSiteOrigin: ev.target.checked ? DOCUMENT_SITE_ORIGIN.GLOBAL : DOCUMENT_SITE_ORIGIN.JAPAN
            }
        })
    }

    handleSubmitFunction = async (e) => {
        e.preventDefault();
        let lockedAbstractRsponse = await this.props.getAbstractLockedByData({ abstractId: +this.abstractId });
        // Check if abstract is already locked or not
        if (lockedAbstractRsponse && lockedAbstractRsponse.data && lockedAbstractRsponse.data.result.length > 0) {
            let lockedResult = lockedAbstractRsponse.data.result[0];
            this.abstractLockedBy = lockedResult.lockedBy;
            if (this.abstractLockedBy && this.abstractLockedBy !== this.loggedUserSystemId) {
                swal('', MessagePool.ABSTRACT_LOCKED_ALERT.replace('{userName}', lockedResult.locker.firstName).replace('{userSystemId}', lockedResult.lockedBy), 'warning');
                return;
            }
        }
        const absFrmData = { ...this.state.abstractForm };

        absFrmData.abstractId = this.abstractId;

        if (absFrmData.explanationId && absFrmData.explanationId.label === "True Duplicate") {
            let res = await swal({
                title: "Are you sure?",
                text: MessagePool.ABSTRACT_LOGICAL_DELETE_CONFIRMATION.replace('{status}', absFrmData.statusId.label),
                icon: "warning",
                buttons: true,
                dangerMode: true,
            });
            if (!res) {
                return false;
            }
        }
        // Array of form dropdown field names
        const formDropDownFields = [
            "productId",
            "countryId",
            "explanationId",
            "statusId",
            "siteProcessingDocument",
            "caseManagerId1",
            "caseManagerId2",
            "caseManagerId3",
        ];
        formDropDownFields.forEach((el) => {
            absFrmData[el] = absFrmData[el] ? absFrmData[el].value : null;
        });

        if (
            [STATUS.DUPLICATE, STATUS.LINKED].includes(
                this.state.staticOriginalStatusId.value
            ) &&
            ![STATUS.DUPLICATE, STATUS.LINKED].includes(absFrmData.statusId)
        ) {
            let res = await swal({
                title: "Are you sure?",
                text: MessagePool.ABSTRACT_DUPLICATE_STATUS_CHANGE_CONFIRMATION,
                icon: "warning",
                dangerMode: true,
            });
            if (!res) {
                return false;
            }
        }


        // Set default SiteOfProcessing based on DocumentSiteOrigin
        if (!absFrmData.siteProcessingDocument) {
            absFrmData.siteProcessingDocument =
                absFrmData.documentSiteOrigin === DOCUMENT_SITE_ORIGIN.GLOBAL ? DOCUMENT_SITE_ORIGIN.GLOBAL : DOCUMENT_SITE_ORIGIN.JAPAN;
        }

        // Format date details fields DATE
        let dateRecordReceived = absFrmData.dateRecordReceived;
        let dateFieldsCheckArr = [];
        let dayDifference = function (d1, d2) {
            var t2 = d2.getTime();
            var t1 = d1.getTime();

            return parseInt((t2 - t1) / (24 * 3600 * 1000));
        }
        Object.keys(this.abstractDateFields).forEach((el) => {
            if (absFrmData[el] && el !== 'dateRecordReceived' && dayDifference(absFrmData[el], dateRecordReceived) >= 1) {
                dateFieldsCheckArr.push(el);
            }
            absFrmData[el] = absFrmData[el] ? yyyymmddFormat(absFrmData[el]) : null;
        });

        // Trim the values
        Object.entries(absFrmData).forEach((data) => {
            const [key, value] = data;
            if (typeof value === "string") {
                absFrmData[key] = value.trim();
            }
        });

        let datesConfirmationResp = true;
        if (dateFieldsCheckArr.length > 0) {
            let dateFieldNames = Helper.formatDateFieldsArrayToString(dateFieldsCheckArr);
            datesConfirmationResp = await swal({
                title: "Are you sure?",
                text: MessagePool.ABSTRACT_DATES_CHECK_CONFIRMATION.replace('{dateFieldNames}', dateFieldNames),
                icon: "warning",
                buttons: true,
                dangerMode: true,
            })
                .then((result) => {
                    if (result) {
                        return true
                    } else {
                        return false;
                    }
                });
        }

        if (!datesConfirmationResp) {
            return false;
        }
        let { keywords, keywordsOldValue } = absFrmData;

        absFrmData['keywords'] = keywordsOldValue !== keywords ? Helper.formatKeywords(keywords) : keywords;
        this.setLoader(true);
        let responseData = await this.props.updateAbstract(absFrmData);

        if (responseData.status === 200) {
            this.abstractLockedBy = this.loggedUserSystemId;
            await this.uploadAndUpdateAbstractAttachment(this.abstractId);

            swal("", MessagePool.UPDATE_ABSTRACT_SUCCESS, "success");


            this.loadAbstractDetail();
            this.loadAbstractAttachments();
            this.calculateDaysOverdueCount()
            this.setLoader(false);
        }
    };

    uploadAndUpdateAbstractAttachment = async (abstractId) => {
        let { fileAttachment, filesToUpload } = this.state;

        //Do not upload files which are unchecked
        filesToUpload.forEach((file) => {
            if (!file.upload) {
                fileAttachment = fileAttachment.filter(x => x.attachmentName !== file.name);
            }
        });

        let formData = new FormData();

        const config = {
            clientId: '0545c53a-54e3-4810-8a25-f1efc1a1fa75',
            openIdCallback: encodeURI('/auth/callback'),
            isGatewayScopeRequired: true,
            gatewayScopeType: 'non_production',
            logLevel: 'INFO',
          }
          // Initialize authProvider for authentication
        let authProvider = new AuthProvider(config);
        const openidAccessToken = await authProvider.getGatewayAccessToken();
        let idToken = openidAccessToken.accessToken;

        if (filesToUpload.length > 0) {
            filesToUpload.forEach((file) => {
                if (file.upload) {
                    formData.append("file", file);
                    formData.append("filePath", `attachment/${abstractId}/${file.name}`);

                }
            });


            let uploadResp = await this.props.uploadAbstractAttachment(formData);
            let errFileResp = []
            if (uploadResp.status !== 200) {
                await swal("", MessagePool.ABSTRACT_DETAIL_FILE_UPLOAD_FAILED_ERROR, "error");
                errFileResp = filesToUpload.map((f) => f.name);
            } else {
                if (uploadResp.data.length > 0) {
                    errFileResp = uploadResp.data;
                }
            }

            errFileResp.forEach((filename) => {
                fileAttachment.forEach((x, i) => {
                    if (x.attachmentName === filename && !x.abstractAttachmentId) {
                        fileAttachment.splice(i, 1);
                    }
                });
            });
        }

        // Reiterate fileAttachment variable to set attachment, abstractId, for new uploaded files
        fileAttachment = fileAttachment.map((x) => {
            if (x.upload) {
                x.abstractId = abstractId;
                x.attachment = `attachment/${abstractId}/${x.attachmentName}`;
            }
            return x;
        });

        // Move unchecked files to Archive Folder on S3
        let archiveFormData = new FormData();
        fileAttachment.forEach(el=>{
            if(!el.active){
                archiveFormData.append('paths[]',el.attachment);
            }
        });
        if(archiveFormData.has('paths[]')){
            await this.props.archiveAttachment(archiveFormData);
        }
        fileAttachment.forEach(el => {
            if(!el.active) {
                let orignalPath = el.attachment;
                let paths = orignalPath.split("/");
                let fileName = paths.pop();
                let newFilePath = [...paths, "Archive", fileName].join("/");
                el.attachment = newFilePath;
            }
        })
        let payload = { fileAttachment }
        return await this.props.addOrUpdateAbstractAttachment(payload);
    };


    handleResetFunction = async () => {
        let res = await swal({
            title: "Are you sure ?",
            text: MessagePool.ABSTRACT_DETAIL_RESET_CONFIRMATION,
            icon: "warning",
            buttons: true,
            dangerMode: true,
        });
        if (!res) {
            return false;
        }
        const { abstractFormCopy, fileAttachmentCopy, inactiveFileAttachmentCopy } = this.state;
        let validationResult = VALIDATION_OBJ.setFormValidity(abstractFormCopy);
        await this.setState({
            ...validationResult,
            abstractForm: abstractFormCopy,
            fileAttachment: fileAttachmentCopy,
            inactiveAttachment: inactiveFileAttachmentCopy,
            filesToUpload: []
        });
    }

    _lockAbstract = () => {
        let updObj = {}
        updObj.abstractId = this.abstractId;
        updObj.createdBy = this.loggedUserSystemId;
        updObj.lockedBy = this.loggedUserSystemId;
        updObj.lockedAt = +new Date();
        updObj.active = true;
        this.props.lockAbstract(updObj);
        this.abstractLockedBy = this.loggedUserSystemId;
    }

    _unlockAbstract = async () => {
        let updObj = {}
        updObj.abstractIds = [+this.abstractId];
        let res = await this.props.unlockAbstract(updObj);
        return res;
    }

    handleCancelFunction = async () => {
        if (this.abstractLockedBy === this.loggedUserSystemId && this.state.action === 'edit') {
            this.setLoader(true);
            let res = await this._unlockAbstract();
            if (res) {
                this.setLoader(false);
                window.close();
            }
        } else {
            window.close();
        }
    }

    openEllipsisModal = (eleLabel, eleName) => {
        const eleValue = this.state.abstractForm[eleName]
        let modalData = { eleLabel, eleName, eleValue }
        this.setState({
            ...this.state,
            showEllipsisModal: true,
            modalData
        })
    }

    openSearchAbstractModal = () => {
        this.setState({
            ...this.state,
            showSearchAbstractModal: true
        })
    }

    /**
     * This function is common for Ellipsis & Search Abstract Modal to HIDE the Modal
     * @param {*} modalName
     */
    hideModal = (modalName) => {
        this.setState({
            ...this.state,
            [modalName]: !this.state[modalName]
        })
    }

    handleOkEllipsisModal = (data) => {
        let identifier = data.eleName;
        let value = data.eleValue;
        if (identifier === 'caseIds') {
            value = Helper.getFormattedCaseIds(value);
        }
        this._validateForm(identifier, value);
    }

    /**
     * originalAbstractData receieves object { originalAbstractId, originAbstractTitle} form Search Modal
     * @param {*} originalAbstractData
     */
    handleOkSearchAbstractModal = (originalAbstractData) => {
        let identifier = "originalAbstractId";
        let value = originalAbstractData.originalAbstractId;
        let updOptionalData = {
            showSearchAbstractModal: false,
            originalAbstractTitle: originalAbstractData.originalAbstractTitle
        }
        this._validateForm(identifier, value, updOptionalData);
    }


    loadAbstractDetail = async () => {
        this.setLoader(true);
        let payload = { action: 'getAbstract', abstractId: this.abstractId };
        const response = await this.props.loadAbstractDetail(payload);
        let result = response.data.result;
        let abstractFormData = {
            originalAbstractId: result.originalAbstractId,
            title: result.title,
            originalTitle: Helper.parseString(result.originalTitle),
            authors: Helper.parseString(result.authors),
            receivedFrom: Helper.parseString(result.receivedFrom),
            source: Helper.parseString(result.source),
            productId: Helper.getDropdownSelectedFormat('product', result),
            institution: Helper.parseString(result.institution),
            caseIds: Helper.parseString(result.caseIds),
            countryId: Helper.getDropdownSelectedFormat('country', result),
            abstract: Helper.parseString(result.abstract),
            notes: Helper.parseString(result.notes),
            keywords: Helper.formatKeywords(result.keywords),
            keywordsOldValue: Helper.formatKeywords(result.keywords),
            documentSiteOrigin: result.documentSiteOrigin,
            siteProcessingDocument: { label: result.siteProcessingDocument, value: result.siteProcessingDocument },
            urlToOvid: Helper.parseString(result.urlToOvid),
            explanationId: Helper.getDropdownSelectedFormat('explanation', result),
            urlToSourceDb: Helper.parseString(result.urlToSourceDb),
            abstractLanguage: Helper.parseString(result.abstractLanguage),
            statusId: Helper.getDropdownSelectedFormat('status', result),
            otherStatus: Helper.parseString(result.otherStatus),
            lockByDate: result.lockByDate,
            caseManagerId1: Helper.getCMDropdownSelectedFormat(result.caseManager1),
            caseManagerId2: Helper.getCMDropdownSelectedFormat(result.caseManager2),
            caseManagerId3: Helper.getCMDropdownSelectedFormat(result.caseManager3),
            migrateFlag: result.migrateFlag,
            enblAlrtsAndVldtinsFlag: result.enblAlrtsAndVldtinsFlag
        }
        function getActualDate(d) {
            let ar = d.split('-');
            let k = new Date(ar[0], ar[1]-1, ar[2]);
            return k;
        }
        Object.keys(this.abstractDateFields).forEach(k => {

            abstractFormData[k] = result[k] ? getActualDate(result[k]) : null;
        });

        // View only screen for deleted abstract
        let action = result.active === false ? 'view' : this.state.action;

        // Manage Locked Abstract
        let formValidityResult = {};

        if (!this.abstractLockedBy && result.active === true && action !== 'view') {
            let lockedAbstractRsponse = await this.props.getAbstractLockedByData({ abstractId: +this.abstractId });
            // Check if abstract is already locked or not
            if (lockedAbstractRsponse && lockedAbstractRsponse.data && lockedAbstractRsponse.data.result.length > 0) {
                let lockedResult = lockedAbstractRsponse.data.result[0];
                this.abstractLockedBy = lockedResult.lockedBy;
                if (this.abstractLockedBy && this.abstractLockedBy !== this.loggedUserSystemId) {
                    action = 'view';
                    swal('', MessagePool.ABSTRACT_LOCKED_ALERT.replace('{userName}', lockedResult.locker.firstName).replace('{userSystemId}', lockedResult.lockedBy), 'warning');
                } else {
                    // Legacy Record Check
                    action = result.migrateFlag === true && result.enblAlrtsAndVldtinsFlag === false ? 'view' : action;

                    formValidityResult = VALIDATION_OBJ.setFormValidity(abstractFormData);
                }
            } else {
                // Legacy Record Check
                action = result.migrateFlag === true && result.enblAlrtsAndVldtinsFlag === false ? 'view' : action;

                formValidityResult = VALIDATION_OBJ.setFormValidity(abstractFormData);
                this._lockAbstract();
            }
        }


        await this.setState({
            ...this.state,
            ...formValidityResult,
            action,
            abstractDataList: [result.originalAbstract],
            originalAbstractTitle: result.originalAbstractId !== null ? result.originalAbstract.title : '',
            originalStatusId: Helper.getDropdownSelectedFormat('status', result),
            staticTitle: result.title,
            staticOriginalStatusId: Helper.getDropdownSelectedFormat('status', result),
            tempEnblAlrtsAndVldtinsFlag: null,
            abstractForm: abstractFormData,
            abstractFormCopy: abstractFormData
        });
        this.setLoader(false);
    }


    loadAbstractAttachments = async () => {
        try {
            this.setLoader(true);
            let payload = {
                action: "getAbstractAttachments",
                abstractId: this.abstractId,
            };
            let response = await this.props.loadAbstractAttachments(payload);
            let attachmentData = response.data.result;

            let activeAttachment = attachmentData.filter(x => x.active === true);
            let inactiveAttachment = attachmentData.filter(x => x.active === false);

            await this.setState({
                ...this.state,
                fileAttachment: activeAttachment,
                fileAttachmentCopy: [...activeAttachment],
                inactiveFileAttachment: inactiveAttachment,
                inactiveFileAttachmentCopy: [...inactiveAttachment],
                filesToUpload: [],
            });
            this.setLoader(false);
        } catch (error) {
            this.setLoader(false);
        }
    };


    openAbstractDetailWindow = (abstractId) => {
        window.open(`/abstractDetail/${abstractId}`, "", `width=${window.innerWidth},height=${window.innerHeight}`);
    }

    handleAuditFunction = () => {
        window.open(`/audit/${this.abstractId}`, "", `width=${window.innerWidth},height=${window.innerHeight}`);
    }

    handleExpandCollapseAll = (flag) => {
        this.setState({
            ...this.state,
            accordionExpandFlag: !flag,
            accordionTabs: {
                ...this.state.accordionTabs,
                event_key_0: flag,
                event_key_1: flag,
                event_key_2: flag,
                event_key_3: flag
            }
        })
    }

    handleClick = (eventKey) => {
        this.setState({
            ...this.state,
            accordionTabs: {
                ...this.state.accordionTabs,
                [`event_key_${eventKey}`]: !this.state.accordionTabs[`event_key_${eventKey}`]
            }
        }, () => {
            const { accordionTabs: { event_key_0, event_key_1, event_key_2 } } = this.state;
            this.setState({
                ...this.state,
                accordionExpandFlag: event_key_0 === true ? false :
                    event_key_1 === true ? false :
                        event_key_2 === true ? false :
                            event_key_0 === false ? true :
                                event_key_1 === false ? true :
                                    event_key_2 === false ? true : this.state.accordionExpandFlag
            })
        })
    }
    handlePrintFunction = () => {
        window.print();
    }

    //** Accordion Button Collapse -and expand */
    ContextAwareToggle = ({ children, eventKey, callback }) => {
        const currentEventKey = useContext(AccordionContext);
        const decoratedOnClick = useAccordionToggle(
            eventKey,
            () => callback && callback(eventKey),
        );
        const isCurrentEventKey = currentEventKey === eventKey;
        return (
            <button
                type="button"
                className="float-right"
                style={
                    {
                        backgroundColor: "transparent",
                        border: "none",
                        color: 'white',
                        transform: !isCurrentEventKey ? 'rotate(0deg)' : 'rotate(180deg)',
                    }}
                onClick={decoratedOnClick}
            >
                {children}
            </button>
        );
    }

    handleFileChange = async (event) => {

        let files = event.target.files;
        let filesArr = [...files];
        let { fileAttachment, inactiveFileAttachment, filesToUpload } = this.state;


        // Validate Maximum number of files can be attached
        let countFiles = fileAttachment.length + filesArr.length;
        if (countFiles > 30) {
            swal("", MessagePool.ABSTRACT_MAX_FILES_ERROR, "error");
            return false;
        }

        // Set upload=1 for new browsed files
        let newFilesArr = filesArr.map((file) => {
            file.upload = 1;
            return file;
        });

        let fileValidation = VALIDATION_OBJ.validateFiles(newFilesArr);
        if (fileValidation.totalInvalidFileNames.length > 0) {
            // Remove the files from the upload array which are invalid
            fileValidation.totalInvalidFileNames.forEach(errFileName => {
                newFilesArr = newFilesArr.filter(f => f.name !== errFileName);
            })
        }


        let newFilesToUpload = [];
        let alreadyUploadedFiles = [];
        newFilesArr.forEach((file) => {
            let isFileExist = fileAttachment.filter(
                (x) => x.attachmentName === file.name
            );
            if (isFileExist.length > 0) {
                alreadyUploadedFiles.push(file.name);
            }

            if (isFileExist.length < 1) {
                let checkInactiveAttachment = inactiveFileAttachment.filter(x => x.attachmentName === file.name);
                let abstractAttachmentId = checkInactiveAttachment.length > 0 ? checkInactiveAttachment[0].abstractAttachmentId : null;
                let faObj = {
                    abstractAttachmentId,
                    active: true,
                    upload: 1,
                    attachmentName: file.name,
                };
                fileAttachment.push(faObj);
            }

            if (filesToUpload.length > 1) {
                filesToUpload.forEach((z, i) => {
                    if (z.name === file.name) {
                        filesToUpload[i] = file;
                    }
                });
                let checkFileExist = filesToUpload.filter((k) => k.name === file.name);
                if (checkFileExist.length < 1) {
                    newFilesToUpload.push(file);
                }
            } else {
                newFilesToUpload.push(file);
            }
        });

        if (fileValidation.totalInvalidFileNames.length > 0) {
            swal('', MessagePool.ABSTRACT_INVALID_FILES_ERROR.replace('{invalidFiles}', fileValidation.totalInvalidFileNames.join(', ')), 'error').then((v) => {
                if (alreadyUploadedFiles.length > 0) {
                    swal('', MessagePool.ABSTRACT_FILE_EXISTS_ALERT.replace('{fileNames}', alreadyUploadedFiles.join(', ')), "warning");
                }
            });
        } else {
            if (alreadyUploadedFiles.length > 0) {
                swal('', MessagePool.ABSTRACT_FILE_EXISTS_ALERT.replace('{fileNames}', alreadyUploadedFiles.join(', ')), "warning");
            }
        }

        filesToUpload = filesToUpload.concat(newFilesToUpload);

        this.setState({
            ...this.state,
            fileAttachment,
            filesToUpload,
        });
    };

    handleAttachmentCheckboxChange(obj) {
        let { fileAttachment, filesToUpload } = this.state;
        fileAttachment = fileAttachment.map((x) => {
            if (x.attachmentName === obj.attachmentName) {
                x.active = !x.active;
            }
            return x;
        });

        filesToUpload = filesToUpload.map((file) => {
            if (file.name === obj.attachmentName) {
                file.upload = +!file.upload;
            }
            return file;
        });

        this.setState({
            ...this.state,
            fileAttachment,
            filesToUpload,
        });
    }

    render() {
        const {
            isLoading,
            action,
            isFormValid,
            isPrimaryDetailsValid,
            isSecondaryDetailsValid,
            isDateDetailsValid,
            showEllipsisModal,
            showSearchAbstractModal,
            modalData,
            productList,
            explanationList,
            countryList,
            statusList,
            caseManagerList,
            originalAbstractTitle,
            staticOriginalStatusId,
            tempEnblAlrtsAndVldtinsFlag,
            staticTitle,
            abstractDataList,
            accordionExpandFlag,
            accordionTabs: {
                event_key_0, event_key_1, event_key_2, event_key_3
            },
            daysOverdue,
            fileAttachment
        } = this.state;

        const {
            title, originalTitle, authors, receivedFrom,
            source, productId, institution,
            caseIds, countryId, documentSiteOrigin,
            abstract, notes, keywords,
            urlToOvid, explanationId, urlToSourceDb,
            statusId, otherStatus,
            caseManagerId1, caseManagerId2, siteProcessingDocument,
            caseManagerId3, abstractLanguage,
            dateRecordReceived, dateTranslationRequested, dateArticleOrdered, dateTranslationReceived,
            dateArticleOrdered2, dateAbstractValid, dateArticleReceived, dateArticleValid,
            dateAbstractReviewed, dateFlwUpReceived, dateArticleReviewed, dateClosed,
            dateTranslationValid, lockByDate,
            migrateFlag, enblAlrtsAndVldtinsFlag
        } = this.state.abstractForm;

        // Appends ellipsis (...) on text based on charLimit
        const ellipsisFormatter = (content, charLimit) => {
            if (content.length > charLimit) {
                return <span>{content.substr(0, charLimit)}...</span>
            } else {
                return content;
            }
        }

        const abstractDataColumns = [
            {
                dataField: 'title',
                text: 'Title',
                headerClasses: 'width-50',
                classes: 'custom-link',
                align: 'left',
                formatter: (cellContent, row) => {
                    const _popOver = (
                        <OverlayTrigger
                            placement="right"
                            popperConfig={{
                                modifiers: {
                                    preventOverflow: {
                                        enabled: false,
                                    },
                                },
                            }}
                            overlay={
                                <Popover style={{ maxWidth: "50vw" }} id="popover-contained">
                                    <Popover.Content>{row && row.title}</Popover.Content>
                                </Popover>
                            }
                        >
                            <span
                                className="fake-link"
                                onClick={() => this.openAbstractDetailWindow(row.abstractId)}
                            >
                                {row && row.title && row.title.length <= 150
                                    ? row.title
                                    : row && row.title && row.title.substr(0, 150) + "..."}
                            </span>
                        </OverlayTrigger>
                    );
                    return row && row.title ? _popOver : "";
                },
                attrs: (cell, row) => {
                    return { title: row && row.title ? row.title : '' }
                }
            },
            {
                dataField: 'authors',
                text: 'Author(s)',
                align: 'left',
                headerClasses: 'width-30',
                formatter: (cellContent, row) => {
                    const _popOver = (
                        <OverlayTrigger
                            placement="right"
                            popperConfig={{
                                modifiers: {
                                    preventOverflow: {
                                        enabled: false,
                                    },
                                },
                            }}
                            overlay={
                                <Popover style={{ maxWidth: "40vw" }} id="popover-contained">
                                    <Popover.Content>{row && row.authors}</Popover.Content>
                                </Popover>
                            }
                        >
                            <div>
                                {row && row.authors && row.authors.length <= 120
                                    ? row.authors
                                    : row && row.authors && row.authors.substr(0, 120) + "..."}
                            </div>
                        </OverlayTrigger>
                    );
                    return row && row.authors ? _popOver : "";
                },
                attrs: (cell, row) => {
                    return { title: row && row.authors ? row.authors : '' }
                }
            },
            {
                dataField: 'source',
                text: 'Source',
                align: 'left',
                headerClasses: 'width-50',
                formatter: (cellContent, row) => {
                    const _popOver = (
                        <OverlayTrigger
                            placement="right"
                            popperConfig={{
                                modifiers: {
                                    preventOverflow: {
                                        enabled: false,
                                    },
                                },
                            }}
                            overlay={
                                <Popover style={{ maxWidth: "40vw" }} id="popover-contained">
                                    <Popover.Content>{row && row.source}</Popover.Content>
                                </Popover>
                            }
                        >
                            <div>
                                {row && row.source && row.source.length <= 70
                                    ? row.source
                                    : row && row.source && row.source.substr(0, 70) + "..."}
                            </div>
                        </OverlayTrigger>
                    );
                    return row && row.source ? _popOver : "";
                },
                attrs: (cell, row) => {
                    return { title: row && row.source ? row.source : '' }
                }
            },
        ];
        function getFieldValue(field) {return (field ? field: '')};

        return (
            <>
                <table className="print-table">
                    <thead>
                        <tr>
                            <td>
                                <div className="page-header-space"></div>
                            </td>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>
                                <div className="CommonWrap printPageWrap">
                                    <Container fluid>
                                        <Form autoComplete="off">
                                            <div className="headerpart headerpartCustom">
                                                <Row>
                                                    <Col sm={7}> <h1>Abstract Detail</h1></Col>
                                                    <Col sm="5" className="text-right ">
                                                        {action === 'edit' && <>
                                                            <Button variant="primary" type="button" onClick={this.handleResetFunction} className="mr-2 btn btn-primary"  >
                                                                Refresh
                                                            </Button>
                                                            <Button variant="primary" type="button" onClick={this.handleSubmitFunction} className="mr-2 btn btn-primary" disabled={!isFormValid} >
                                                                Save
                                                            </Button></>}

                                                        <Button variant="primary" type="button" className="btn btn-primary mr-2" onClick={() => this.handlePrintFunction()}>
                                                            Print
                                                        </Button>
                                                        {
                                                            accordionExpandFlag ?
                                                                <Button type="button" className="btn btn-primary mr-2" onClick={() => this.handleExpandCollapseAll(true)}>Expand All</Button> :
                                                                <Button type="button" className="btn btn-primary mr-2" onClick={() => this.handleExpandCollapseAll(false)}>Collapse All</Button>
                                                        }
                                                        <Button variant="primary" type="reset" className="btn btn-primary" onClick={this.handleCancelFunction}>
                                                            Close
                                                        </Button>
                                                    </Col>
                                                </Row>

                                                <Row><Col><label><b>Title :</b></label> <span>{staticTitle}</span></Col></Row>

                                                <Row>
                                                    {staticOriginalStatusId && [STATUS.DUPLICATE, STATUS.LINKED].includes(staticOriginalStatusId.value) && <Col><label><b>Status :</b></label><label>{staticOriginalStatusId.label}</label></Col>}
                                                    <Col className="text-right mandatory_info"><span>* </span> Mandatory Fields </Col>
                                                </Row>



                                                {staticOriginalStatusId && [STATUS.DUPLICATE, STATUS.LINKED].includes(staticOriginalStatusId.value) &&
                                                    <div className="abstractDataList">
                                                        <DataTable
                                                            keyField="title"
                                                            data={abstractDataList}
                                                            columns={abstractDataColumns}
                                                            csvName={false}
                                                            showSearch={false}
                                                            showPagination={false}
                                                        />
                                                    </div>
                                                }

                                                {migrateFlag === true && <div>
                                                    <Row><Col><label><b>Legacy Record </b></label> </Col></Row>
                                                    <Row>
                                                        <Col>
                                                            <label>
                                                                <Form.Group controlId="enblAlrtsAndVldtinsFlag">
                                                                    <Form.Check
                                                                        type="checkbox"
                                                                        disabled={!tempEnblAlrtsAndVldtinsFlag && (enblAlrtsAndVldtinsFlag === true || this.abstractLockedBy !== this.loggedUserSystemId)}
                                                                        name="enblAlrtsAndVldtinsFlag"
                                                                        onChange={this.handleEnableAlertsValidationChange}
                                                                        checked={enblAlrtsAndVldtinsFlag === true}
                                                                        label="Enable Alerts & Validations" />
                                                                </Form.Group>
                                                            </label>
                                                        </Col>
                                                    </Row> </div>
                                                }
                                            </div>

                                            <div className="abstractDetailForm">
                                                <Accordion activeKey={event_key_0 ? "0" : ''}>
                                                    <Card>
                                                        <Accordion.Toggle as={Card.Header} eventKey="0" onClick={(e) => this.handleClick(0)}>
                                                            Primary Details {isPrimaryDetailsValid && action === 'edit' ? <FaCheckCircle className="checkCircleD" /> : ''}
                                                            <this.ContextAwareToggle eventKey="0">
                                                                <FaChevronDown></FaChevronDown>
                                                            </this.ContextAwareToggle>
                                                        </Accordion.Toggle>

                                                        <Accordion.Collapse ref={this.accordionRef_0} eventKey="0" >
                                                            <Card.Body>
                                                                <div className="primaryDetails">
                                                                    <Row>
                                                                        <Col sm={4} className="pr-0 print-100">
                                                                            <Form.Group controlId="title">
                                                                                <Form.Label>Title<span className="mandatory">*</span>
                                                                                </Form.Label>
                                                                                <InputGroup printvalue={title}>
                                                                                    <Form.Control
                                                                                        type="text"
                                                                                        name="title"
                                                                                        value={title}
                                                                                        onChange={this.handleInputChange}
                                                                                        isInvalid={action === 'edit' && VALIDATION_OBJ.title.error}
                                                                                        disabled={action === "view" || action === "cancel" ? true : false} />
                                                                                    <InputGroup.Append>
                                                                                        <Button onClick={() => this.openEllipsisModal('Title', 'title')}>...</Button>
                                                                                    </InputGroup.Append>
                                                                                    <Form.Control.Feedback type="invalid">{VALIDATION_OBJ.title.error}</Form.Control.Feedback>
                                                                                </InputGroup>
                                                                            </Form.Group>
                                                                        </Col>

                                                                        <Col sm={4} className="pr-0 print-100">
                                                                            <Form.Group controlId="originalTitle">
                                                                                <Form.Label>Original Title</Form.Label>
                                                                                <InputGroup printvalue={originalTitle}>
                                                                                    <Form.Control
                                                                                        type="text"
                                                                                        name="originalTitle"
                                                                                        value={getFieldValue(originalTitle)}
                                                                                        onChange={this.handleInputChange}
                                                                                        isInvalid={action === 'edit' && VALIDATION_OBJ.originalTitle.error}
                                                                                        disabled={action === "view" || action === "cancel" ? true : false} />
                                                                                    <InputGroup.Append>
                                                                                        <Button onClick={() => this.openEllipsisModal('Original Title', 'originalTitle')}>...</Button>
                                                                                    </InputGroup.Append>
                                                                                    <Form.Control.Feedback type="invalid">{VALIDATION_OBJ.originalTitle.error}</Form.Control.Feedback>
                                                                                </InputGroup>
                                                                            </Form.Group>
                                                                        </Col>

                                                                        <Col sm={4} className="print-100">
                                                                            <Form.Group controlId="authors">
                                                                                <Form.Label>Author(s) <span className="mandatory">*</span>
                                                                                </Form.Label>
                                                                                <InputGroup printvalue={authors}>
                                                                                    <Form.Control
                                                                                        type="text"
                                                                                        name="authors"
                                                                                        value={authors} onChange={this.handleInputChange}
                                                                                        isInvalid={action === 'edit' && VALIDATION_OBJ.authors.error}
                                                                                        disabled={action === "view" || action === "cancel" ? true : false} />
                                                                                    <InputGroup.Append>
                                                                                        <Button onClick={() => this.openEllipsisModal('Authors', 'authors')}>...</Button>
                                                                                    </InputGroup.Append>
                                                                                    <Form.Control.Feedback type="invalid">{VALIDATION_OBJ.authors.error}</Form.Control.Feedback>
                                                                                </InputGroup>
                                                                            </Form.Group>
                                                                        </Col>

                                                                    </Row>

                                                                    <Row>

                                                                        <Col sm={4} className="pr-0 print-100" >
                                                                            <Form.Group controlId="receivedFrom">
                                                                                <Form.Label>Received From <span className="mandatory">*</span>
                                                                                </Form.Label>
                                                                                <InputGroup printvalue={receivedFrom}>
                                                                                    <Form.Control
                                                                                        type="text"
                                                                                        name="receivedFrom"
                                                                                        value={receivedFrom}
                                                                                        onChange={this.handleInputChange}
                                                                                        isInvalid={action === 'edit' && VALIDATION_OBJ.receivedFrom.error}
                                                                                        disabled={action === "view" || action === "cancel" ? true : false} />
                                                                                    <Form.Control.Feedback type="invalid">{VALIDATION_OBJ.receivedFrom.error}</Form.Control.Feedback>
                                                                                </InputGroup>
                                                                            </Form.Group>

                                                                        </Col>
                                                                        <Col sm={4} className="pr-0 print-100">
                                                                            <Form.Group controlId="source">
                                                                                <Form.Label>Source <span className="mandatory">*</span>
                                                                                </Form.Label>
                                                                                <InputGroup printvalue={source}>
                                                                                    <Form.Control
                                                                                        type="text"
                                                                                        name="source"
                                                                                        value={source}
                                                                                        onChange={this.handleInputChange}
                                                                                        isInvalid={action === 'edit' && VALIDATION_OBJ.source.error}
                                                                                        disabled={action === "view" || action === "cancel" ? true : false} />
                                                                                    <InputGroup.Append>
                                                                                        <Button onClick={() => this.openEllipsisModal('Source', 'source')}>...</Button>
                                                                                    </InputGroup.Append>
                                                                                    <Form.Control.Feedback type="invalid">{VALIDATION_OBJ.source.error}</Form.Control.Feedback>
                                                                                </InputGroup>
                                                                            </Form.Group>
                                                                        </Col>

                                                                        <Col sm={4} className="print-100" >
                                                                            <Form.Group controlId="productId">
                                                                                <Form.Label> Product </Form.Label>
                                                                                <Select
                                                                                    name="productId"
                                                                                    styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                                                                                    menuPortalTarget={document.body}
                                                                                    options={productList}
                                                                                    value={productId}
                                                                                    maxMenuHeight={130}
                                                                                    isClearable={true}
                                                                                    isDisabled={action === 'view' ? true : false}
                                                                                    onChange={selectedOption =>
                                                                                        this.handleSelectChange("productId", selectedOption)}

                                                                                />
                                                                            </Form.Group>
                                                                        </Col>
                                                                    </Row>

                                                                    <Row>
                                                                        <Col sm={4} className="pr-0 print-100">
                                                                            <Form.Group controlId="institution">
                                                                                <Form.Label>Institution</Form.Label>
                                                                                <InputGroup printvalue={institution}>
                                                                                    <Form.Control type="text" name="institution"
                                                                                        value={getFieldValue(institution)} onChange={this.handleInputChange}
                                                                                        disabled={action === "view" || action === "cancel" ? true : false} />
                                                                                    <InputGroup.Append>
                                                                                        <Button onClick={() => this.openEllipsisModal('Institution', 'institution')} >...</Button>
                                                                                    </InputGroup.Append>
                                                                                </InputGroup>
                                                                            </Form.Group>
                                                                        </Col>
                                                                        <Col sm={4} className="pr-0 print-100">
                                                                            <Form.Group controlId="caseIds">
                                                                                <Form.Label>Case ID {VALIDATION_OBJ.caseIds.shouldValidate && <span className="mandatory">*</span>}</Form.Label>
                                                                                <InputGroup printvalue={caseIds}>
                                                                                    <Form.Control type="text" name="caseIds"
                                                                                        value={getFieldValue(caseIds)} onChange={this.handleInputChange}
                                                                                        isInvalid={action === 'edit' && VALIDATION_OBJ.caseIds.error}
                                                                                        disabled={action === "view" || action === "cancel" ? true : false} />
                                                                                    <InputGroup.Append>
                                                                                        <Button onClick={() => this.openEllipsisModal('Case ID', 'caseIds')} >...</Button>
                                                                                    </InputGroup.Append>
                                                                                    <Form.Control.Feedback type="invalid">{VALIDATION_OBJ.caseIds.error}</Form.Control.Feedback>
                                                                                </InputGroup>
                                                                            </Form.Group>
                                                                        </Col>

                                                                        <Col sm={4} className="print-100">
                                                                            <Form.Group controlId="countryId">
                                                                                <Form.Label> Country</Form.Label>
                                                                                <Select
                                                                                    name="countryId"
                                                                                    styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                                                                                    menuPortalTarget={document.body}
                                                                                    options={countryList}
                                                                                    value={countryId}
                                                                                    maxMenuHeight={130}
                                                                                    isClearable={true}
                                                                                    isDisabled={action === 'view' ? true : false}
                                                                                    onChange={selectedOption =>
                                                                                        this.handleSelectChange("countryId", selectedOption)}

                                                                                />

                                                                            </Form.Group>
                                                                        </Col>

                                                                    </Row>

                                                                    <Row>
                                                                        <Col sm={4} className="pr-0 print-100">
                                                                            <Form.Group controlId="abstract">
                                                                                <Form.Label>Abstract</Form.Label>
                                                                                <InputGroup printvalue={abstract}>
                                                                                    <Form.Control as="textarea" rows="10" name="abstract"
                                                                                        onChange={this.handleInputChange} value={getFieldValue(abstract)}
                                                                                        disabled={action === "view" ? true : false} />
                                                                                    <InputGroup.Append>
                                                                                        <Button className="btnEllipsis" onClick={() => this.openEllipsisModal('Abstract', 'abstract')} >...</Button>
                                                                                    </InputGroup.Append>
                                                                                </InputGroup>
                                                                            </Form.Group>
                                                                        </Col>
                                                                        <Col sm={4} className="pr-0 print-100" >
                                                                            <Form.Group controlId="keywords">
                                                                                <Form.Label>Keywords</Form.Label>
                                                                                <InputGroup printvalue={keywords}>
                                                                                    <Form.Control as="textarea" rows="10" name="keywords"
                                                                                        onChange={this.handleInputChange} value={getFieldValue(keywords)}
                                                                                        disabled={action === "view" ? true : false} />
                                                                                    <InputGroup.Append>
                                                                                        <Button className="btnEllipsis" onClick={() => this.openEllipsisModal('Keywords', 'keywords')}>...</Button>
                                                                                    </InputGroup.Append>
                                                                                </InputGroup>
                                                                            </Form.Group>
                                                                        </Col>

                                                                        <Col sm={4} className="print-100">
                                                                            <Form.Group controlId="notes">
                                                                                <Form.Label>Notes</Form.Label>
                                                                                <InputGroup printvalue={notes}>
                                                                                    <Form.Control as="textarea" rows="10" name="notes"
                                                                                        onChange={this.handleInputChange} value={getFieldValue(notes)}
                                                                                        disabled={action === "view" ? true : false} />
                                                                                    <InputGroup.Append>
                                                                                        <Button className="btnEllipsis" onClick={() => this.openEllipsisModal('Notes', 'notes')} >...</Button>
                                                                                    </InputGroup.Append>
                                                                                </InputGroup>
                                                                            </Form.Group>
                                                                        </Col>
                                                                    </Row>
                                                                    <Row>
                                                                        <Col sm={4} className="pr-0 print-100">
                                                                            <Form.Group controlId="documentSiteOrigin">
                                                                                <Form.Label> Site of Origin</Form.Label>
                                                                                <ToggleSwitch id="documentSiteOrigin" onChange={this.handleSwitch}
                                                                                    Text={[DOCUMENT_SITE_ORIGIN.GLOBAL, DOCUMENT_SITE_ORIGIN.JAPAN]}
                                                                                    currentValue={documentSiteOrigin === DOCUMENT_SITE_ORIGIN.GLOBAL}
                                                                                    disabled={action === "view" || action === "edit" ? true : false}
                                                                                />
                                                                            </Form.Group>
                                                                        </Col>
                                                                    </Row>
                                                                </div>

                                                            </Card.Body>
                                                        </Accordion.Collapse>
                                                    </Card>
                                                </Accordion>

                                                <Accordion activeKey={event_key_1 ? "1" : ''}>
                                                    <Card>

                                                        <Accordion.Toggle as={Card.Header} eventKey="1" onClick={(e) => this.handleClick(1)}>
                                                            Secondary Details {isSecondaryDetailsValid && action === 'edit' ? <FaCheckCircle className="checkCircleD" /> : ''}
                                                            <this.ContextAwareToggle eventKey="1">
                                                                <FaChevronDown></FaChevronDown>
                                                            </this.ContextAwareToggle>
                                                        </Accordion.Toggle>

                                                        <Accordion.Collapse eventKey="1" >
                                                            <Card.Body>
                                                                <div className="secondaryDetails">
                                                                    <Row>
                                                                        <Col sm={4} className="pr-0 print-100">
                                                                            <Form.Group controlId="urlToOvid">
                                                                                <Form.Label>URL to OVID/MEDLINE/JMED/JAPIC-Q</Form.Label>
                                                                                <InputGroup printvalue={urlToOvid}>
                                                                                    <Form.Control type="text" name="urlToOvid"
                                                                                        isInvalid={action === 'edit' && VALIDATION_OBJ.urlToOvid.error}
                                                                                        value={getFieldValue(urlToOvid)} onChange={this.handleInputChange}
                                                                                        disabled={action === "view" || action === "cancel" ? true : false} />
                                                                                    <Form.Control.Feedback type="invalid">{VALIDATION_OBJ.urlToOvid.error}</Form.Control.Feedback>
                                                                                </InputGroup>
                                                                            </Form.Group>
                                                                        </Col>
                                                                        <Col sm={4} className="print-100">
                                                                            <Form.Group controlId="urlToSourceDb">
                                                                                <Form.Label>URL to Source Database</Form.Label>
                                                                                <InputGroup printvalue={urlToSourceDb}>
                                                                                    <Form.Control type="text" name="urlToSourceDb"
                                                                                        value={getFieldValue(urlToSourceDb)} onChange={this.handleInputChange}
                                                                                        disabled={action === "view" || action === "cancel" ? true : false} />
                                                                                    <InputGroup.Append>
                                                                                        <Button onClick={() => this.openEllipsisModal('URL to Source Database', 'urlToSourceDb')} >...</Button>
                                                                                    </InputGroup.Append>
                                                                                </InputGroup>
                                                                            </Form.Group>
                                                                        </Col>
                                                                        <Col sm={4} >
                                                                            <Form.Group controlId="abstractLanguage">
                                                                                <Form.Label>Language  </Form.Label>
                                                                                <InputGroup printvalue={abstractLanguage}>
                                                                                    <Form.Control
                                                                                        type="text"
                                                                                        name="abstractLanguage"
                                                                                        value={abstractLanguage}
                                                                                        onChange={this.handleInputChange}
                                                                                        disabled={action === "view" || action === "cancel" ? true : false}
                                                                                    />
                                                                                </InputGroup>
                                                                            </Form.Group>
                                                                        </Col>

                                                                        <Col sm={4} className="pr-0">
                                                                            <Form.Group controlId="statusId">
                                                                                <Form.Label> Status <span className="mandatory">*</span>
                                                                                </Form.Label>
                                                                                <Select
                                                                                    name="statusId"
                                                                                    classNamePrefix="select"
                                                                                    className={VALIDATION_OBJ.statusId.error ? "reactSelect" : ""}
                                                                                    styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                                                                                    menuPortalTarget={document.body}
                                                                                    options={statusList}
                                                                                    value={statusId}
                                                                                    maxMenuHeight={130}
                                                                                    isClearable={true}
                                                                                    isDisabled={action === 'view' ? true : false}
                                                                                    onChange={selectedOption =>
                                                                                        this.handleSelectChange("statusId", selectedOption)}

                                                                                >
                                                                                </Select>
                                                                                <div className={VALIDATION_OBJ.statusId.error ? "selectInvalidFeedback" : ""} >{VALIDATION_OBJ.statusId.error}</div>
                                                                            </Form.Group>
                                                                        </Col>
                                                                        <Col sm={4}>
                                                                            <Form.Group controlId="otherStatus">
                                                                                <Form.Label>Other Status</Form.Label>
                                                                                <InputGroup printvalue={urlToSourceDb}>
                                                                                    <Form.Control type="text" name="otherStatus"
                                                                                        value={otherStatus} onChange={this.handleInputChange}
                                                                                        isInvalid={action === 'edit' && VALIDATION_OBJ.otherStatus.error}
                                                                                        disabled={action === "view" || action === "cancel" ? true : false} />
                                                                                    <InputGroup.Append>
                                                                                        <Button onClick={() => this.openEllipsisModal('Other Status', 'otherStatus')}>...</Button>
                                                                                    </InputGroup.Append>
                                                                                    <Form.Control.Feedback type="invalid">{VALIDATION_OBJ.otherStatus.error}</Form.Control.Feedback>
                                                                                </InputGroup>
                                                                            </Form.Group>
                                                                        </Col>
                                                                        <Col sm={4} >
                                                                            <Form.Group controlId="lockByDate">
                                                                                <Form.Label>Lock  By Date </Form.Label>
                                                                                <MyDatePicker
                                                                                    name='lockByDate'
                                                                                    selected={lockByDate}
                                                                                    onDateChange={this.handleDateChange}
                                                                                    disabled={action === 'view' ? true : false}
                                                                                    isInvalid={!VALIDATION_OBJ.lockByDate.valid}
                                                                                >
                                                                                    <Form.Control.Feedback type='invalid'>{VALIDATION_OBJ.lockByDate.error}</Form.Control.Feedback>
                                                                                </MyDatePicker>
                                                                            </Form.Group>
                                                                        </Col>

                                                                    </Row>
                                                                    <Row>
                                                                        <Col sm={4} className="pr-0">
                                                                            <Form.Group controlId="originalAbstractId">
                                                                                <Form.Label>Original Abstract {VALIDATION_OBJ.originalAbstractId.shouldValidate && <span className="mandatory">*</span>}</Form.Label>
                                                                                <InputGroup printvalue={originalAbstractTitle}>
                                                                                    <Form.Control type="text" name="originalAbstractId" readOnly
                                                                                        isInvalid={action === 'edit' && VALIDATION_OBJ.originalAbstractId.error}
                                                                                        title={originalAbstractTitle}
                                                                                        value={originalAbstractTitle} onChange={this.handleInputChange}
                                                                                    />
                                                                                    <InputGroup.Append>
                                                                                        <Button onClick={this.openSearchAbstractModal} variant="primary" disabled={VALIDATION_OBJ.statusId.valid && (statusId || staticOriginalStatusId) ? !([statusId.value, staticOriginalStatusId.value].includes(STATUS.LINKED)) : true} ><FaSearch /></Button>
                                                                                    </InputGroup.Append>
                                                                                    <Form.Control.Feedback type="invalid">{VALIDATION_OBJ.originalAbstractId.error}</Form.Control.Feedback>
                                                                                </InputGroup>
                                                                            </Form.Group>

                                                                        </Col>
                                                                        <Col sm={4} >
                                                                            <Form.Group controlId="explanationId">
                                                                                <Form.Label>Explanation  {VALIDATION_OBJ.explanationId.shouldValidate && <span className="mandatory">*</span>}</Form.Label>
                                                                                <Select
                                                                                    name="explanationId"
                                                                                    classNamePrefix="select"
                                                                                    className={VALIDATION_OBJ.explanationId.error ? "reactSelect" : ""}
                                                                                    styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                                                                                    menuPortalTarget={document.body}
                                                                                    options={explanationList}
                                                                                    value={explanationId}
                                                                                    maxMenuHeight={130}
                                                                                    isClearable={true}
                                                                                    isDisabled={action === 'view' ? true : false}
                                                                                    isOptionDisabled={(option) => option.disabled === true}
                                                                                    onChange={selectedOption =>
                                                                                        this.handleSelectChange("explanationId", selectedOption)}

                                                                                >
                                                                                </Select>
                                                                                <div className={VALIDATION_OBJ.explanationId.error ? "selectInvalidFeedback" : ""} >{VALIDATION_OBJ.explanationId.error}</div>

                                                                            </Form.Group>
                                                                        </Col>
                                                                        <Col sm={4} >
                                                                            <Form.Group controlId="siteProcessingDocument">
                                                                                <Form.Label> Site of Processing
                                                                                </Form.Label>
                                                                                <Select
                                                                                    name="siteProcessingDocument"
                                                                                    styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                                                                                    menuPortalTarget={document.body}
                                                                                    options={SITE_PROCESSING_DOCUMENT}
                                                                                    value={siteProcessingDocument}
                                                                                    maxMenuHeight={130}
                                                                                    isClearable={true}
                                                                                    isDisabled={action === 'view' ? true : false}
                                                                                    onChange={selectedOption =>
                                                                                        this.handleSelectChange("siteProcessingDocument", selectedOption)}

                                                                                />
                                                                            </Form.Group>
                                                                        </Col>
                                                                    </Row>
                                                                    <Row>
                                                                        <Col sm={4} className="pr-0">
                                                                            <Form.Group controlId="caseManagerId1">
                                                                                <Form.Label>Abstract Record Screener {VALIDATION_OBJ.caseManagerId1.shouldValidate && <span className="mandatory">*</span>}</Form.Label>
                                                                                <Select
                                                                                    name="caseManagerId1"
                                                                                    classNamePrefix="select"
                                                                                    className={VALIDATION_OBJ.caseManagerId1.error ? "reactSelect" : ""}
                                                                                    styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                                                                                    menuPortalTarget={document.body}
                                                                                    options={caseManagerList}
                                                                                    value={caseManagerId1}
                                                                                    maxMenuHeight={130}
                                                                                    isClearable={true}
                                                                                    isDisabled={action === 'view' ? true : false}
                                                                                    onChange={selectedOption =>
                                                                                        this.handleSelectChange("caseManagerId1", selectedOption)}
                                                                                />
                                                                                <div className={VALIDATION_OBJ.caseManagerId1.error ? "selectInvalidFeedback" : ""} >{VALIDATION_OBJ.caseManagerId1.error}</div>
                                                                            </Form.Group>
                                                                        </Col>
                                                                        <Col sm={4} >
                                                                            <Form.Group controlId="caseManagerId2">
                                                                                <Form.Label>Full Text Screener
                                                                                </Form.Label>
                                                                                <Select
                                                                                    name="caseManagerId2"
                                                                                    styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                                                                                    menuPortalTarget={document.body}
                                                                                    options={caseManagerList}
                                                                                    value={caseManagerId2}
                                                                                    maxMenuHeight={130}
                                                                                    isClearable={true}
                                                                                    isDisabled={action === 'view' ? true : false}
                                                                                    onChange={selectedOption =>
                                                                                        this.handleSelectChange("caseManagerId2", selectedOption)}

                                                                                />
                                                                            </Form.Group>
                                                                        </Col>
                                                                        <Col sm={4} >
                                                                            <Form.Group controlId="caseManagerId3">
                                                                                <Form.Label> Record Closer
                                                                                </Form.Label>
                                                                                <Select
                                                                                    name="caseManagerId3"
                                                                                    styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                                                                                    menuPortalTarget={document.body}
                                                                                    options={caseManagerList}
                                                                                    value={caseManagerId3}
                                                                                    maxMenuHeight={130}
                                                                                    isClearable={true}
                                                                                    isDisabled={action === 'view' ? true : false}
                                                                                    onChange={selectedOption =>
                                                                                        this.handleSelectChange("caseManagerId3", selectedOption)}

                                                                                />
                                                                            </Form.Group>
                                                                        </Col>

                                                                    </Row>
                                                                    <Row>
                                                                        <Col sm={4}>
                                                                            <Form.Group controlId="fileSelect">
                                                                                <Form.Label className={`btn btn-primary mt-4 ${action === "view" || action === "cancel" ? 'disabled' : ''}`} >
                                                                                    File Attachment
                                                                                </Form.Label>
                                                                                <Form.Control
                                                                                    value=""
                                                                                    onClick={(e) =>
                                                                                        (e.target.value = null)
                                                                                    }
                                                                                    isInvalid={true}
                                                                                    disabled={action === "view" || action === "cancel" ? true : false}
                                                                                    type="file"
                                                                                    placeholder="Browse"
                                                                                    name="fileAttachment"
                                                                                    multiple={true}
                                                                                    onChange={(evt) =>
                                                                                        this.handleFileChange(evt)
                                                                                    }
                                                                                    className="fileSelectStyle"
                                                                                />
                                                                                <Form.Control.Feedback type='invalid'>{MessagePool.FILE_ATTACHMENTS_RULES_UI}</Form.Control.Feedback>
                                                                                <table className="mt-2">
                                                                                    <tbody>
                                                                                        {fileAttachment &&
                                                                                            fileAttachment.length > 0 &&
                                                                                            [...fileAttachment].map(
                                                                                                (data, index) => {
                                                                                                    let downloadUrl = data.attachment ? encodeURI(`${config.Backend_S3_URL}/download/?filename=${data.attachment}`) : null;
                                                                                                    return (
                                                                                                        <tr key={index}>
                                                                                                            <td>

                                                                                                                <a href='#' target="_blank"  onClick={e => this.TriggerEvent(e,downloadUrl)}>
                                                                                                                    {data.attachmentName}
                                                                                                                </a>
                                                                                                            </td>
                                                                                                            <td>
                                                                                                                <Form.Check
                                                                                                                    type="checkbox"
                                                                                                                    disabled={action === "view" || action === "cancel" ? true : false} name="attachment[]"
                                                                                                                    onChange={() => this.handleAttachmentCheckboxChange(data)}
                                                                                                                    checked={data.active}
                                                                                                                />
                                                                                                            </td>
                                                                                                        </tr>
                                                                                                    );
                                                                                                }
                                                                                            )}
                                                                                    </tbody>
                                                                                </table>
                                                                            </Form.Group>
                                                                        </Col>
                                                                    </Row>

                                                                </div>

                                                            </Card.Body>
                                                        </Accordion.Collapse>
                                                    </Card>
                                                </Accordion>
                                                <Accordion activeKey={event_key_2 ? "2" : ''} >
                                                    <Card>

                                                        <Accordion.Toggle as={Card.Header} eventKey="2" onClick={(e) => this.handleClick(2)}>
                                                            Date Details {isDateDetailsValid && action === 'edit' ? <FaCheckCircle className="checkCircleD" /> : ''}
                                                            <this.ContextAwareToggle eventKey="2">
                                                                <FaChevronDown></FaChevronDown>
                                                            </this.ContextAwareToggle>
                                                        </Accordion.Toggle>

                                                        <Accordion.Collapse eventKey="2" >
                                                            <Card.Body>
                                                                <div className="dateDetails">
                                                                    <Row>
                                                                        <Col sm={3} className="pr-0">
                                                                            <Form.Group controlId="dateRecordReceived">
                                                                                <Form.Label>Date Record Received <span className="mandatory">*</span>
                                                                                </Form.Label>
                                                                                <MyDatePicker
                                                                                    name='dateRecordReceived'
                                                                                    selected={dateRecordReceived}
                                                                                    onDateChange={this.handleDateChange}
                                                                                    disabled={action === 'view' ? true : false}
                                                                                    isInvalid={action === 'edit' && !VALIDATION_OBJ.dateRecordReceived.valid && VALIDATION_OBJ.dateRecordReceived.touched}
                                                                                >
                                                                                    <Form.Control.Feedback type='invalid'>{VALIDATION_OBJ.dateRecordReceived.error}</Form.Control.Feedback>
                                                                                </MyDatePicker>
                                                                            </Form.Group>
                                                                        </Col>
                                                                        <Col sm={3} className="pr-0">
                                                                            <Form.Group controlId="dateArticleOrdered">
                                                                                <Form.Label>Date Article Ordered</Form.Label>
                                                                                <MyDatePicker
                                                                                    name='dateArticleOrdered'
                                                                                    selected={dateArticleOrdered}
                                                                                    onDateChange={this.handleDateChange}
                                                                                    disabled={action === 'view' ? true : false}
                                                                                />
                                                                            </Form.Group>
                                                                        </Col>
                                                                        <Col sm={3} className="pr-0">
                                                                            <Form.Group controlId="dateArticleReceived">
                                                                                <Form.Label>Date Article Received </Form.Label>
                                                                                <MyDatePicker
                                                                                    name='dateArticleReceived'
                                                                                    selected={dateArticleReceived}
                                                                                    onDateChange={this.handleDateChange}
                                                                                    disabled={action === 'view' ? true : false}
                                                                                />
                                                                            </Form.Group>
                                                                        </Col>
                                                                        <Col sm={3} >
                                                                            <Form.Group controlId="dateAbstractValid">
                                                                                <Form.Label>Date Abstract Valid
                                                                                </Form.Label>
                                                                                <MyDatePicker
                                                                                    name='dateAbstractValid'
                                                                                    selected={dateAbstractValid}
                                                                                    onDateChange={this.handleDateChange}
                                                                                    disabled={action === 'view' ? true : false}
                                                                                    isInvalid={action === 'edit' && !VALIDATION_OBJ.dateAbstractValid.shouldValidate && VALIDATION_OBJ.dateAbstractValid.error}
                                                                                >
                                                                                    <Form.Control.Feedback type='invalid'>{VALIDATION_OBJ.dateAbstractValid.error}</Form.Control.Feedback>
                                                                                </MyDatePicker>
                                                                            </Form.Group>
                                                                        </Col>
                                                                    </Row>

                                                                    <Row>
                                                                        <Col sm={3} className="pr-0">
                                                                            <Form.Group controlId="dateAbstractReviewed">
                                                                                <Form.Label>Date Record Reviewed</Form.Label>
                                                                                <MyDatePicker
                                                                                    name='dateAbstractReviewed'
                                                                                    selected={dateAbstractReviewed}
                                                                                    onDateChange={this.handleDateChange}
                                                                                    disabled={action === 'view' ? true : false}
                                                                                />
                                                                            </Form.Group>
                                                                        </Col>
                                                                        <Col sm={3} className="pr-0">
                                                                            <Form.Group controlId="dateArticleOrdered2">
                                                                                <Form.Label>Date Article Ordered 2</Form.Label>
                                                                                <MyDatePicker
                                                                                    name='dateArticleOrdered2'
                                                                                    selected={dateArticleOrdered2}
                                                                                    onDateChange={this.handleDateChange}
                                                                                    disabled={action === 'view' ? true : false}
                                                                                />
                                                                            </Form.Group>
                                                                        </Col>
                                                                        <Col sm={3} className="pr-0">
                                                                            <Form.Group controlId="dateArticleReviewed">
                                                                                <Form.Label>Date Article Reviewed  </Form.Label>
                                                                                <MyDatePicker
                                                                                    name='dateArticleReviewed'
                                                                                    selected={dateArticleReviewed}
                                                                                    onDateChange={this.handleDateChange}
                                                                                    disabled={action === 'view' ? true : false}
                                                                                />
                                                                            </Form.Group>
                                                                        </Col>
                                                                        <Col sm={3} >
                                                                            <Form.Group controlId="dateArticleValid">
                                                                                <Form.Label>Date Article Valid {VALIDATION_OBJ.dateArticleValid.shouldValidate && <span className="mandatory">*</span>}
                                                                                </Form.Label>
                                                                                <MyDatePicker
                                                                                    name='dateArticleValid'
                                                                                    selected={dateArticleValid}
                                                                                    onDateChange={this.handleDateChange}
                                                                                    disabled={action === 'view' ? true : false}
                                                                                    isInvalid={action === 'edit' && !VALIDATION_OBJ.dateArticleValid.shouldValidate && VALIDATION_OBJ.dateArticleValid.error}
                                                                                >
                                                                                    <Form.Control.Feedback type='invalid'>{VALIDATION_OBJ.dateArticleValid.error}</Form.Control.Feedback>
                                                                                </MyDatePicker>
                                                                            </Form.Group>
                                                                        </Col>
                                                                    </Row>
                                                                    <Row>
                                                                        <Col sm={3}></Col>
                                                                        <Col sm={3} className="pr-0">
                                                                            <Form.Group controlId="dateTranslationRequested">
                                                                                <Form.Label>Date Translation Requested</Form.Label>
                                                                                <MyDatePicker
                                                                                    name='dateTranslationRequested'
                                                                                    selected={dateTranslationRequested}
                                                                                    onDateChange={this.handleDateChange}
                                                                                    disabled={action === 'view' ? true : false}
                                                                                />
                                                                            </Form.Group>
                                                                        </Col>
                                                                        <Col sm={3} className="pr-0">
                                                                            <Form.Group controlId="dateTranslationReceived">
                                                                                <Form.Label>Date Translation Received
                                                                                </Form.Label>
                                                                                <MyDatePicker
                                                                                    name='dateTranslationReceived'
                                                                                    selected={dateTranslationReceived}
                                                                                    onDateChange={this.handleDateChange}
                                                                                    disabled={action === 'view' ? true : false}
                                                                                />
                                                                            </Form.Group>
                                                                        </Col>
                                                                        <Col sm={3} >
                                                                            <Form.Group controlId="dateTranslationValid">
                                                                                <Form.Label>Date Translation Valid </Form.Label>
                                                                                <MyDatePicker
                                                                                    name='dateTranslationValid'
                                                                                    selected={dateTranslationValid}
                                                                                    onDateChange={this.handleDateChange}
                                                                                    disabled={action === 'view' ? true : false}
                                                                                />
                                                                            </Form.Group>
                                                                        </Col>
                                                                    </Row>

                                                                    <Row>
                                                                        <Col sm={3}></Col>
                                                                        <Col sm={3}></Col>
                                                                        <Col sm={3} className="pr-0">
                                                                            <Form.Group controlId="dateFlwUpReceived">
                                                                                <Form.Label>Date Follow-up Received</Form.Label>
                                                                                <MyDatePicker
                                                                                    name='dateFlwUpReceived'
                                                                                    selected={dateFlwUpReceived}
                                                                                    onDateChange={this.handleDateChange}
                                                                                    disabled={action === 'view' ? true : false}
                                                                                />
                                                                            </Form.Group>
                                                                        </Col>
                                                                        <Col sm={3}>
                                                                            <Form.Group controlId="dateClosed">
                                                                                <Form.Label>Date Closed {VALIDATION_OBJ.dateClosed.shouldValidate && !VALIDATION_OBJ.dateClosed.validation.notRequired && <span className="mandatory">*</span>}</Form.Label>
                                                                                <MyDatePicker
                                                                                    name='dateClosed'
                                                                                    selected={dateClosed}
                                                                                    onDateChange={this.handleDateChange}
                                                                                    disabled={action === 'view' ? true : false}
                                                                                    isInvalid={action === 'edit' && VALIDATION_OBJ.dateClosed.shouldValidate && VALIDATION_OBJ.dateClosed.error}
                                                                                >
                                                                                    <Form.Control.Feedback type='invalid'>{VALIDATION_OBJ.dateClosed.error}</Form.Control.Feedback>
                                                                                </MyDatePicker>
                                                                            </Form.Group>
                                                                        </Col>
                                                                    </Row>
                                                                </div>

                                                            </Card.Body>
                                                        </Accordion.Collapse>
                                                    </Card>
                                                </Accordion>

                                                <div>
                                                    <h4 style={{ marginTop: "10px" }}>Days Overdue for:</h4>
                                                    <Row className="mb-1">
                                                        <Col sm={3}>Reviewing an Abstract after Receipt:</Col>
                                                        <Col>{daysOverdue.absNotRevAftRecp}</Col>
                                                    </Row>
                                                    <Row className="mb-1">
                                                        <Col sm={3}>Returning a Translation Request:</Col>
                                                        <Col>{daysOverdue.transNotRetnAftReq}</Col>
                                                    </Row>
                                                    <Row className="mb-1">
                                                        <Col sm={3}>Receiving an Article after Initial Order:</Col>
                                                        <Col>{daysOverdue.artNotRecAftOrd}</Col>
                                                    </Row>
                                                    <Row className="mb-1">
                                                        <Col sm={3}>Reviewing an Article after receipt:</Col>
                                                        <Col>{daysOverdue.artNotRevAftRec}</Col>
                                                    </Row>
                                                </div>

                                                <Row className="print-hide">
                                                    <Col className="text-right mt-3">
                                                        {action === 'edit' && <>
                                                            <Button variant="primary" type="button" onClick={this.handleResetFunction} className="mr-2 btn btn-primary" >
                                                                Refresh
                                                            </Button>
                                                            <Button variant="primary" type="button" onClick={this.handleSubmitFunction} className="mr-2 btn btn-primary" disabled={!isFormValid}>
                                                                Save
                                                            </Button> </>}
                                                        <Button variant="primary" type="button" className="mr-2 btn btn-primary" onClick={this.handlePrintFunction}>
                                                            Print
                                                        </Button>
                                                        <Button variant="primary" type="button" className="btn btn-primary mr-2" onClick={this.handleAuditFunction}>
                                                            Audit Trail
                                                        </Button>
                                                        <Button variant="primary" type="reset" className="btn btn-primary" onClick={this.handleCancelFunction}>
                                                            Close
                                                        </Button>
                                                    </Col>
                                                </Row>
                                            </div>
                                        </Form>
                                    </Container>
                                </div>
                                {isLoading && (
                                    <div className="loader">
                                        <FaSpinner />
                                    </div>
                                )}

                                {showEllipsisModal &&
                                    <EllipsisModal showEllipsisModal={showEllipsisModal}
                                        onHide={() => this.hideModal('showEllipsisModal')}
                                        modalData={modalData}
                                        disableText={action === 'view' ? true : false}
                                        handleOkEllipsisModal={this.handleOkEllipsisModal}
                                    />}
                                {showSearchAbstractModal &&
                                    <SearchAbstractModal showSearchAbstractModal={showSearchAbstractModal}
                                        onHide={() => this.hideModal('showSearchAbstractModal')}
                                        abstractId={this.abstractId}
                                        onOk={this.handleOkSearchAbstractModal}
                                    />}
                            </td>
                        </tr>
                    </tbody>
                    <tfoot>
                        <tr>
                            <td>
                                <div className="page-footer-space"></div>
                            </td>
                        </tr>
                    </tfoot>
                </table>

            </>
        );
    }
}


const mapStateToProps = state => {
    return {
        loggedUserDetail: state.userDataReducer.loggedUserDetail,
        productData: state.abstractDataReducer.productData,
        countryData: state.abstractDataReducer.countryData,
        statusData: state.abstractDataReducer.statusData,
        explanationData: state.abstractDataReducer.explanationData
    };
};

const mapDispatchToProps = dispatch => {
    return bindActionCreators(
        {
            loadAllProduct,
            loadAllCountry,
            loadAllExplanation,
            loadAllStatus,
            loadAbstractDetail,
            loadAllAlerts,
            updateAbstract,
            lockAbstract,
            unlockAbstract,
            getAbstractLockedByData,
            uploadAbstractAttachment,
            loadAbstractAttachments,
            addOrUpdateAbstractAttachment,
            archiveAttachment
        },
        dispatch
    );
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(AbstractDetail));
